export const CART_UPSELL_TEMPLATE_CATEGORY = 'cart-upsell'

// The tile-before-after thumbnail's source photo, inside its border; crops for it are cut at this aspect.
export const TILE_BEFORE_AFTER_SOURCE_PHOTO_SIZE_PX = { width: 45, height: 56 }
